/* Djurslottet - Om oss:
   1) galleribilderna tonar in nar de scrollas fram
   2) efter ett skickat kontaktformular stannar sidan kvar vid formularet

   Om (2): Shopify laddar om sidan med ?contact_posted=true och ankaret #djom-contact.
   Webblasaren hoppar dit direkt, men sidan ar da inte fardigbyggd - bilder och
   videoposters far sin hojd efterat och puttar formularet nedat, sa besokaren
   hamnar hogt upp pa sidan i stallet for vid sin egen kvittens. Vi scrollar
   darfor dit igen nar allt har laddat klart. */
(function () {
  var items = document.querySelectorAll('.djom__gal li');
  if (items.length) {
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { threshold: 0.15 });
      for (var j = 0; j < items.length; j++) io.observe(items[j]);
    }
  }

  if (location.search.indexOf('contact_posted') === -1) return;

  function toForm() {
    var target = document.querySelector('.djom__form-ok') || document.querySelector('.djom__contact');
    if (!target) return;
    try { target.scrollIntoView({ block: 'center', behavior: 'auto' }); }
    catch (e) { target.scrollIntoView(); }
    if (target.focus) { try { target.focus({ preventScroll: true }); } catch (e2) {} }
  }

  /* En gang nar sidan ar uppbyggd, och en gang till nar allt laddat klart -
     posterbilderna kan andra hojden mellan de tva tillfallena. */
  if (document.readyState === 'complete') toForm();
  else window.addEventListener('load', toForm);
  setTimeout(toForm, 400);
})();